import axios from 'axios';

const API_URL = process.env.REACT_APP_FRONT_API_URL;

export interface Product {
  id: string;
  name: string;
  price: number;
  imageUrl: string;
  image?: string;
  description: string;
  rating?: number;
  reviews?: number;
  features?: string[];
  isNew?: boolean;
  category?: string;
}

const ProductService = {
  getAllProducts: async (): Promise<Product[]> => {
    try {
      const response = await axios.get(`${API_URL}/products`);
      return response.data.map((product: any) => ({
        ...product,
        price: Number(product.price) || 0,
      }));
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  },

  getProductById: async (id: string): Promise<Product> => {
    try {
      const response = await axios.get(`${API_URL}/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du produit:', error);
      throw error;
    }
  },
};

export default ProductService;
